<template>
  <div style="height: 100%">
    <GmapMap
      :center="mapCenter"
      :zoom="7"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      :options="{styles: mapStyles}">
      <template v-for="apl in apls">
        <GmapMarker
          :key="apl._id + 'marker'"
          :position="apl.center"
          :clickable="true"
          @click="showApl(apl)"
          :label="{ text: apl.icon.showLabel ? `${apl.name}, ${apl.county}` : ' ', fontWeight: 'normal' }"
          :icon="{
            url: getIcon(apl.icon),
            scaledSize: { width: 40 * apl.icon.scale, height: 60 * apl.icon.scale },
            origin: { x: 0, y: 0 },
            anchor: { x: (40 * apl.icon.scale) / 2, y: 60 * apl.icon.scale },
            labelOrigin: { x: (40 * apl.icon.scale) / 2, y: 60 * apl.icon.scale + 10 }
          }"
        />
        <GmapPolygon :paths="decodePath(apl)" :options="polyOptions(apl)" :key="apl._id + 'poly'" />
      </template>
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import mapStyles from '@/mapstyles/default.json'
import SERVER_URL from '@/config'

export default {
  name: 'avizier-index',

  data: () => ({
    apls: [],
    mapCenter: {
      lat: 46.0043292,
      lng: 25.1010639
    },
    mapStyles
  }),

  computed: {
    google: gmapApi,
    decodePath () {
      return apl => {
        if (this.google) {
          const poly = this.google.maps.geometry.encoding.decodePath(apl.borders.polyString)

          return poly
        } else {
          return []
        }
      }
    },
    polyOptions () {
      return apl => ({
        fillColor: apl.borders.fill,
        strokeColor: apl.borders.stroke,
        // fillOpacity
        // strokeOpacity
        // strokeWeight
      })
    }
  },

  methods: {
    showApl (apl) {
      this.$router.push({ name: 'APLMap', params: { id: apl._id }, meta: { apl } })
    },
    getIcon (icon) {
      return SERVER_URL + icon.url + `?${new Date().getTime()}`
    }
  },

  async mounted () {
    try {
      const apls = await this.$store.dispatch('fetchAllAPLs', true)
      this.apls = Object.freeze(apls)
    } catch (err) {
      console.log(err)
    }
  }
}
</script>
